import { render, staticRenderFns } from "./ProyectoEdit.vue?vue&type=template&id=3a4a332e&scoped=true&"
import script from "./ProyectoEdit.vue?vue&type=script&lang=js&"
export * from "./ProyectoEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4a332e",
  null
  
)

export default component.exports